import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { object } from 'prop-types';
import { countrySelectorOptions } from './iframeConstructorConfig';
import {
  getFormStyles,
  getLabelStyles,
  getFieldStyles,
  getAdditionalFieldStyles,
  getFormGroupStyles,
  getButtonStyles,
} from './iframeConstructorHelpers';

const propTypes = {
  intl: intlShape.isRequired,
  config: object.isRequired,
};


const IframeConstructorPreview = ({ config, intl }) => {
  return (
    <form
      className="iframe-form-preview"
      action="/order"
      method="POST"
      style={getFormStyles(config)}
      id="iframe-preview"
      onSubmit={e => {
        e.preventDefault();
      }}
    >
      <div className="form-container">
        {config.additional.countrySelector !== 'hide' && (
          <div className="form-group" style={getFormGroupStyles(config)}>
            <label htmlFor="demo-country" style={getLabelStyles(config)}>
              <FormattedMessage
                id="iframe_constructor.preview.form.select.label"
                defaultMessage="Country"
              />
            </label>
            <select
              id="demo-country"
              name="country"
              className="form-control"
              style={getFieldStyles(config)}
            >
              {countrySelectorOptions.map(option => (
                <option key={option.id}>
                  {intl.formatMessage({
                    id: option.id,
                    defaultMessage: option.defaultMessage,
                  })}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="form-group" style={getFormGroupStyles(config)}>
          <label htmlFor="demo-name" style={getLabelStyles(config)}>
            <FormattedMessage
              id="iframe_constructor.preview.form.name.label"
              defaultMessage="Full name"
            />
          </label>
          <input
            id="demo-name"
            name="name"
            className="form-control"
            style={getFieldStyles(config)}
          />
          {config.additional.showExamples && (
            <small className="form-text" style={getAdditionalFieldStyles(config)}>
              <FormattedMessage
                id="iframe_constructor.preview.form.name.example"
                defaultMessage="Example: Tom Johnson"
              />
            </small>
          )}
        </div>

        <div className="form-group" style={getFormGroupStyles(config)}>
          <label htmlFor="demo-phone" style={getLabelStyles(config)}>
            <FormattedMessage
              id="iframe_constructor.preview.form.phone.label"
              defaultMessage="Mob.phone"
            />
          </label>
          <input
            type="phone"
            id="demo-phone"
            name="phone"
            className="form-control"
            style={getFieldStyles(config)}
          />
          {config.additional.showExamples && (
            <small className="form-text" style={getAdditionalFieldStyles(config)}>
              <FormattedMessage
                id="iframe_constructor.preview.form.phone.example"
                defaultMessage="Example: +44 123456789"
              />
            </small>
          )}
        </div>

        {config.additional.showPrivacyAgreement && (
          <div className="checkbox agreement" style={getAdditionalFieldStyles(config)}>
            <label htmlFor="demo-agreement">
              <input id="demo-agreement" type="checkbox" defaultChecked />{' '}
              <FormattedMessage
                id="iframe_constructor.preview.form.agreement"
                defaultMessage="I agree with processing of my personal data"
              />
            </label>
          </div>
        )}

        <button className="btn btn-submit" type="button" style={getButtonStyles(config)}>
          {config.button.text}
        </button>
      </div>
    </form>
  );
};

IframeConstructorPreview.propTypes = propTypes;

export default injectIntl(IframeConstructorPreview);
